















import Vue from "vue";
import { Component } from "vue-property-decorator";
import NumberPad from "@/components/Money/numberPad.vue";
import FormItem from "@/components/Money/FormItem.vue";
import Tags from "@/components/Money/Tags.vue";
import store from "@/store/index";
import typeList from "@/constants/typeList";
import Tabs from "@/components/Tabs.vue";
@Component({
  components: { NumberPad, FormItem, Tags, Tabs }
})
export default class Money extends Vue {
  // data
  record: RecordItem = {
    tags: [],
    notes: "",
    type: "-",
    amount: 0
  };
  typeList = typeList;
  // hooks
  created() {
    this.$store.commit("fetchRecords");
  }
  // computed
  get recordList() {
    return this.$store.state.recordList;
  }
  get tags() {
    // TODO
    return this.$store.state.tagList;
  }
  // methods
  onUpdateTags(tags: Tag[]) {
    this.record.tags = tags;
  }
  saveRecord(e: any) {
    if (this.record.tags.length === 0) {
      return window.alert("至少选择一个标签");
    }
    this.$store.commit("createRecord", this.record);
    if (this.$store.state.createRecordError === null) {
      window.alert("已保存");
      this.$store.commit("fetchTag");
    }
  }
}
